const requireDirectice = require.context('./module', true, /\.js$/);

// console.log(requireDirectice);

export default (Vue) => {
    

    requireDirectice.keys().forEach(key => {
        
        let key_name = key.replace(/(\.\/|\.js)/g, '');
        
        Vue.directive(key_name, requireDirectice(key).default);

        

        // console.log();
    });



    // console.log(Vue);
}
